package com.patronat.top.features.dashboard.presentation

import com.arkivanov.decompose.ComponentContext
import com.patronat.top.dto.UserRole

class DefaultMainComponent(
    componentContext: ComponentContext,
    override val userRole: UserRole,
    private val onLogout: () -> Unit
) : MainComponent, ComponentContext by componentContext {

    override fun onLogoutClicked() {
        onLogout()
    }
}